import React from "react";
import { withStyles } from "@material-ui/core/styles";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import style from "style";

export const CarouselArrow = withStyles(style)(
  ({ className, style, onClick, classes, direction }) => {
    return (
      <div className={className} style={{ ...style }} onClick={onClick}>
        {direction === "prev" ? (
          <ChevronLeft className={classes.chevronArrow} />
        ) : (
          <ChevronRight className={classes.chevronArrow} />
        )}
      </div>
    );
  }
);

export default CarouselArrow;
